import { useAuthenticatedRequestCreator } from "hooks/useRequests";

interface AccountBalance {
  balanceInCents: number;
}

const useCustomerConsignmentBalance = () => {
  const getBalance = useAuthenticatedRequestCreator<AccountBalance, string>(
    (customerId: string) => ({
      method: "GET",
      url: `/payout-requests/customers/${customerId}/consignment-balance`,
    })
  );

  return { getBalance };
};

export default useCustomerConsignmentBalance;